/* shto-reviews: our buttons drive the store's own Judge.me widget (sections/shto-reviews.liquid).
   - "Write a review" clicks Judge.me's own (hidden) Write a review button, so Judge.me's form opens.
   - "Load more reviews" keeps the reviews already shown (copies, in a box above Judge.me's list) and clicks Judge.me's
     own next-page button, so the next page appears under them. The scroll position stays where it was. Hidden when
     Judge.me has no next page. A new sort starts over from Judge.me's first page.
   - "Showing [sort] reviews" follows the chosen sort.
   - If the page has no rating breakdown from the server, it is filled from the data Judge.me's block prints.
   Nothing here changes the address or Judge.me's settings. */
(() => {
  const init = (section) => {
    if (section.dataset.shtoReviewsReady) return;
    section.dataset.shtoReviewsReady = '1';
    const widget = () => section.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    const more = section.querySelector('[data-shto-reviews-more]');
    const moreWrap = more ? more.closest('.shto-reviews__more') : null;
    const showing = section.querySelector('[data-shto-reviews-showing]');

    const nextButton = () => {
      const w = widget(); if (!w) return null;
      const nav = w.querySelector('.jm-pagination-controls, .jdgm-paginate');
      if (!nav) return null;
      return nav.querySelector('[aria-label="Go to next page"]') || [...nav.querySelectorAll('.jm-pagination-controls__button--nav, .jdgm-paginate__next-page')].pop() || null;
    };
    const usable = (b) => !!b && !b.disabled && b.getAttribute('aria-disabled') !== 'true' && !b.classList.contains('jm-button--disabled');

    const earlierBox = () => {
      const w = widget(); if (!w) return null;
      let box = w.querySelector(':scope > .shto-reviews__earlier');
      if (!box) { box = document.createElement('div'); box.className = 'shto-reviews__earlier'; w.prepend(box); }
      return box;
    };
    const clearEarlier = () => { const box = widget()?.querySelector(':scope > .shto-reviews__earlier'); if (box) box.replaceChildren(); };

    const update = () => {
      const w = widget();
      if (moreWrap && w && w.querySelector('.jm-review-widget, .jdgm-rev-widg')) moreWrap.hidden = !usable(nextButton());
      if (showing) {
        const select = w?.querySelector('select');
        const label = select?.selectedOptions?.[0]?.textContent?.trim();
        if (label) showing.textContent = showing.dataset.shtoReviewsShowing.replace('[sort]', label.toLowerCase());
      }
    };

    section.querySelector('[data-shto-reviews-write]')?.addEventListener('click', () => {
      const w = widget();
      const own = w?.querySelector('[data-testid="write-review-button"], .jm-write-review-button, .jdgm-write-rev-link');
      if (own) own.click();
      else w?.scrollIntoView({ block: 'start' });
    });

    more?.addEventListener('click', () => {
      const w = widget(); const next = nextButton();
      if (!w || !usable(next)) return;
      const list = w.querySelector('.jdgm-review-list');
      const items = list ? [...list.children].filter((n) => n.nodeType === 1) : [];
      const firstBefore = items[0]?.getAttribute('review-uuid') || items[0]?.textContent;
      const box = earlierBox();
      if (box) for (const item of items) { const copy = item.cloneNode(true); copy.removeAttribute('id'); copy.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id')); box.append(copy); }
      const y = window.scrollY;
      // Stop putting the page back as soon as the shopper scrolls on their own.
      let moved = false;
      const stop = () => { moved = true; };
      ['wheel', 'touchstart', 'keydown'].forEach((t) => window.addEventListener(t, stop, { once: true, passive: true }));
      more.disabled = true;
      next.click();
      // Judge.me scrolls to the top of its widget when it changes page: put the page back where it was.
      const keep = () => window.scrollTo({ top: y, behavior: 'instant' });
      const started = Date.now();
      const wait = () => {
        const now = w.querySelector('.jdgm-review-list')?.firstElementChild;
        const changed = now && (now.getAttribute('review-uuid') || now.textContent) !== firstBefore;
        if (changed || Date.now() - started > 8000) {
          more.disabled = false;
          [0, 80, 250, 600, 1000, 1500].forEach((t) => setTimeout(() => { if (!moved) keep(); }, t));
          update();
        } else requestAnimationFrame(wait);
      };
      requestAnimationFrame(wait);
    });

    section.addEventListener('change', (e) => { if (e.target.matches('select')) { clearEarlier(); setTimeout(update, 50); } });

    let queued = false;
    new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); })
      .observe(section.querySelector('.shto-reviews__widget') || section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
    update();

    // Breakdown fallback: Judge.me's block also prints its numbers as data for its script.
    const dist = section.querySelector('[data-shto-dist-missing]');
    const id = section.dataset.productId;
    const fill = () => {
      const h = window.jdgm?.data?.reviewWidget?.[id]?.histogram;
      if (!dist || !Array.isArray(h)) return false;
      const total = h.reduce((s, r) => s + (+r.frequency || 0), 0) || 1;
      for (const r of h) {
        const row = dist.querySelector(`[data-rating="${r.rating}"]`); if (!row) continue;
        row.querySelector('.shto-reviews__bar-count').textContent = r.frequency;
        row.querySelector('.shto-reviews__bar-fill').style.width = `${(r.frequency / total) * 100}%`;
      }
      return true;
    };
    if (dist && !fill()) window.addEventListener('load', fill, { once: true });
  };
  const run = () => document.querySelectorAll('[data-shto-section="shto-reviews"]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
